export const DeleteGroupModal: string = 'DeleteGroupModal';
